module.exports = __webpack_public_path__ + "static/media/amproved_bg.ed758cf7.jpg";